import {axiosGet, urlGenerator} from "../../../common/Helper/AxiosHelper";
import {TENANT_BASE_URL} from "../../../common/Config/UrlHelper";
import DatatableHelperMixin from "../../../common/Mixin/Global/DatatableHelperMixin";

export default {
    mixins: [DatatableHelperMixin],
    data() {
        const tab = this.$parent.$props.tabs.find(e => e.component === 'app-hotel-pricing')
        return {
            urlGenerator,
            options: {
                name             : this.$t('pricing'),
                url              : `${TENANT_BASE_URL}app/hotel/pricing?hotel_id=${tab.hotel.id}`,
                showHeader       : true,
                tableShadow      : false,
                tablePaddingClass: 'pt-primary',
                columns          : [
                    {
                        title    : this.$t('actions'),
                        type     : 'action',
                        key      : 'id',
                        isVisible: true
                    },
                    {
                        title    : this.$t('type'),
                        type     : 'custom-html',
                        key      : 'type',
                        isVisible: true,
                        modifier : (data, row) => {
                            return data?.name ?? '-';
                        }
                    },
                    {
                        title    : this.$t('cleaning'),
                        type     : 'custom-html',
                        key      : 'cleaning',
                        isVisible: true,
                        modifier : (data, row) => {
                            return data?.name ?? '-';
                        }
                    },
                    {
                        title    : this.$t('selling_price'),
                        type     : 'text',
                        key      : 'selling_price',
                        isVisible: true,
                    },
                    {
                        title    : this.$t('contract_price'),
                        type     : 'text',
                        key      : 'contract_price',
                        isVisible: true,
                    },
                ],
                filters          : [
                    {
                        title         : this.$t('type'),
                        type          : "multi-select-filter",
                        key           : "type",
                        option        : [],
                        listValueField: 'name',
                        permission    : !!this.$can('view_hotel_list')
                    },
                ],
                paginationType   : "pagination",
                responsive       : true,
                rowLimit         : 10,
                showAction       : true,
                orderBy          : 'desc',
                actionType       : 'default',
                actions          : [
                    {
                        title   : this.$t('edit'),
                        icon    : 'edit',
                        type    : 'modal',
                        modifier: row => this.$can('update_hotel_pricing')
                    },
                    {
                        title    : this.$t('delete'),
                        icon     : 'trash-2',
                        type     : 'modal',
                        component: 'app-confirmation-modal',
                        modalId  : 'app-confirmation-modal',
                        url      : `${TENANT_BASE_URL}app/hotel/pricing/`,
                        name     : 'delete',
                        modifier : row => this.$can('delete_hotel_pricing')
                    }
                ],
            }
        }
    },
    mounted() {
        this.getFilterValues()
    },
    methods: {
        getFilterValues() {
            const tab        = this.$parent.$props.tabs.find(e => e.component === 'app-hotel-pricing')
            const Error      = error => this.$toastr.e(error.response.data.message)
            const typeFilter = this.options.filters.find(item => item.key === 'type');

            axiosGet(`${TENANT_BASE_URL}selectable/hotel/type?hotel_id=${tab.hotel.id}`)
                .then(({data}) => typeFilter.option = data)
                .catch(Error)
        },
    },
}